import React from "react";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { checkPermissions } from "@comps/commonFunctions";
import "./layouts-styles.css";

const BaseHeader = (props) => {
  const { children, headers, modkey, className } = props;

  const getChildren = () => {
    // Remove Create button if user does not have create permission
    if (children === undefined || !children) {
      return null;
    }

    let actionItems = React.Children.toArray(children).filter(Boolean);
    let index = null;

    actionItems.forEach((each, key) => {
      if (
        each.props !== undefined &&
        each.props.onClick !== undefined &&
        each.props.onClick.name === "onCreate"
      ) {
        if (!checkPermissions(modkey, "create")) {
          index = key;
        }
      }
    });

    if (props.moduleKey === "customPayitem") {
      index = null;
    }

    if (index !== null) {
      actionItems = actionItems.slice(0, index).concat(actionItems.slice(index + 1));
    }

    return actionItems.length ? actionItems : null;
  };

  const renderBreadcrumb = () => {
    if (!headers?.breadcrumb?.length) {
      return null;
    }

    return (
      <Breadcrumb className="base-header__breadcrumb">
        { headers.breadcrumb.map((each, index) => {
          const label = each.path ? <Link to={ each.path }>{ each.name }</Link> : each.name;

          return <Breadcrumb.Item key={ each.path || `${each.name}-${index}` }>{ label }</Breadcrumb.Item>;
        }) }
      </Breadcrumb>
    );
  };

  const actions = getChildren();
  const subtitle = headers?.subtitle || headers?.description;

  return (
    <div className={ ["base-header da-px-32", className].filter(Boolean).join(" ") }>
      <div className="base-header__surface page-header">
        <div className="base-header__content">
          <div className="base-header__title-block">
            { renderBreadcrumb() }
            <div className="base-header__title-row">
              <h1 className="base-header__title">{ headers?.title }</h1>
              { subtitle ? <p className="base-header__subtitle">{ subtitle }</p> : null }
            </div>
          </div>

          { actions ? <div className="base-header__actions">{ actions }</div> : null }
        </div>
      </div>
    </div>
  );
};

export default BaseHeader;
